module.exports = __webpack_public_path__ + "static/img/illu-1.dc4e580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/illu-1.png
// module id = 317
// module chunks = 9